<template>
    <div class="page-order page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="24">
                    <h3 style="float: none;">售后单列表</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>订单管理</el-breadcrumb-item>
                            <el-breadcrumb-item>售后单列表</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
            </el-row>
            <div class="bd">
                <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <el-form-item prop="id" label="ID：">
                            <el-input v-model="form_search.id" type='number' size="small" placeholder="请输入售后单ID" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="order_number" label="订单号：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.order_number" size="small" placeholder="请输入订单号" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="mobile" label="下单手机号：">
                            <el-input v-model="form_search.mobile" type='number' size="small" placeholder="下单手机号" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="transaction_id" label="微信支付单号：">
                            <el-input v-model="form_search.transaction_id" size="small" placeholder="请输入微信支付单号" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="balance_pay_number" label="余额支付单号：">
                            <el-input v-model="form_search.balance_pay_number" size="small" placeholder="请输入余额支付单号" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="admin_id" label="管理员：">
                            <el-select size="small" v-model="form_search.admin_id" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in init_data.admin_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="reason_type" label="退款原因：">
                            <el-select size="small" v-model="form_search.reason_type" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in init_data.reason_type_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="pay_type" label="支付方式：">
                            <el-select size="small" v-model="form_search.pay_type" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in init_data.pay_type_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="type" label="退款类型：">
                            <el-select size="small" v-model="form_search.type" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in init_data.type_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="status" label="退款状态：">
                            <el-select size="small" v-model="form_search.status" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in init_data.status_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="下单时间：">
                            <el-date-picker
                                    size="small"
                                    clearable
                                    v-model="create_range"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="退款完成时间：">
                            <el-date-picker
                                    size="small"
                                    clearable
                                    v-model="complete_range"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;" @sort-change="orderSortChange">
                            <el-table-column prop="id" align="center" label="ID" min-width="80">
                            </el-table-column>
                            <el-table-column prop="order_number" align="center" label="订单编号" min-width="160">
                            </el-table-column>
							<el-table-column prop="user_number" align="center" label="用户编号" min-width="160">
							    <template slot-scope="scope">
							        <span class="user-num-span" @click="$util.goTo('/user/list',{query:{user_number:scope.row.user_number}})">{{scope.row.user_number}}</span>
							    </template>
							</el-table-column>
                            <el-table-column prop="mobile" align="center" label="手机号" min-width="120">
                            </el-table-column>
                            <el-table-column prop="avatar_url" align="center" label="用户头像" min-width="80">
                                <template slot-scope="scope">
                                    <img class="cursor" :src="scope.row.avatar_url" height="23" @click="dlg_preview.img_url = scope.row.avatar_url;dlg_preview.visible = true;" title="点击查看" />
                                </template>
                            </el-table-column>
							<el-table-column prop="paid_amount" align="center" label="实付金额" min-width="80">
							</el-table-column>
                            <el-table-column prop="refund_amount" align="center" label="退款金额" min-width="80">
                            </el-table-column>
                            <el-table-column prop="type_name" align="center" label="退款类型" min-width="150">
                                <template slot-scope="scope">
                                    <span :class="'tag-span tag-'+scope.row.type">{{scope.row.type_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="reason_type_name" align="center" label="退款原因" min-width="150">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.reason_type_name"></my-textEllipsis>
                                </template>
                            </el-table-column>
							<el-table-column prop="admin_name" align="center" label="管理员" min-width="80">
							</el-table-column>
                            <el-table-column prop="admin_remark" align="center" label="退款备注" min-width="160">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.admin_remark"></my-textEllipsis>
                                </template>
                            </el-table-column>
                            <el-table-column prop="refund_status_name" align="center" label="状态" min-width="80">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.refund_status">{{scope.row.refund_status_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="pay_type" align="center" label="余额支付单号/微信支付单号" min-width="230">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.pay_type==1">{{scope.row.transaction_id}}</span>
                                    <span v-else-if="scope.row.pay_type==2">{{scope.row.balance_pay_number}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="pay_type_name" align="center" label="支付方式" min-width="120">
                                <template slot-scope="scope">
                                    <span :class="'tag-span tag-'+(scope.row.pay_type+1)">{{scope.row.pay_type_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="c_time" sortable="custom" align="center" label="下单时间" min-width="160">
                            </el-table-column>
                            <el-table-column prop="refund_complete_date" sortable="custom" align="center" label="退款完成时间" min-width="160">
                            </el-table-column>
                            <el-table-column prop="operating" align="right" label="操作" min-width="140" fixed="right">
                                <template slot-scope="scope">
                                    <el-button v-if="(scope.row.type==2||scope.row.type==3)&&scope.row.refund_status===1" class="option-btn btn-bd-o" type="primary" size="mini" @click="goToDelivery(scope.row.order_number,scope.row.pay_type)">审核</el-button>
                                    <el-button class="option-btn btn-bd-m" type="primary" size="mini" @click="$util.goTo('/order/orderlist',{query:{order_number:scope.row.order_number,type:'after'}})">详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
		<!-- 退款窗口 -->
        <el-dialog class="dialog-export refund-dialog" title="退款审核" :visible.sync="dlg_refund.visible" width="534px" @closed="closeRefund" :close-on-click-modal="false">
            <el-form ref="formRefund" :model="dlg_refund.form" label-width="110px" :rules="dlg_refund.rules" @submit.native.prevent>
                <el-form-item prop="refund_amount" style="margin-top: 15px;" label="退款金额：" :error="dlg_refund.error.out_refund_no">
                    <el-input size="small" type='number' v-model="dlg_refund.form.refund_amount" placeholder='请输入退款金额' clearable></el-input>
                </el-form-item>
                <el-form-item v-if="dlg_refund.pay_type==1" prop="out_refund_no" style="margin-top: 15px;" label="微信退款单号：" :error="dlg_refund.error.out_refund_no">
                    <el-input size="small" type='number' v-model="dlg_refund.form.out_refund_no" placeholder='请输入微信退款单号' clearable></el-input>
                </el-form-item>
                <el-form-item prop="admin_remark" label="描述：">
                    <el-input v-model="dlg_refund.form.admin_remark" type="textarea" :rows="3" size="small" placeholder="请输入描述"></el-input>
                </el-form-item>
				<el-form-item prop="status" label="审批：">
				    <el-radio-group v-model="dlg_refund.form.do_result">
				        <el-radio v-for="(item, index) in dlg_refund.do_result_list" :key="index" :label="item.id">{{item.name}}</el-radio>
				    </el-radio-group>
				</el-form-item>
				<el-form-item prop="password" label="员工密码：">
					<el-input type="password" size="small" v-model="dlg_refund.form.password"></el-input>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dlg_refund.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitRefund()" :loading="dlg_refund.btn_loading">确认</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
            <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                create_range:'',
                complete_range:'',
                form_search:{
                    id:'',
                    order_number:'',
                    mobile:"",
                    //remark:'',
                    transaction_id:'',
                    balance_pay_number:'',
                    admin_id:-1,
                    type:-1,
                    pay_type:-1,
                    reason_type:-1,
                    status: -1,
                    start_create_date:'',
                    end_create_date:'',
                    start_complete_date:'',
                    end_complete_date:''
                },
                init_data: {
                    pay_type_list:[],
                    type_list:[],
                    status_list: [],
                    reason_type_list:[],
                    admin_list:[]
                },
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 10,
                        total: 130
                    }
                },
                dlg_refund:{
                    visible:false,
                    btn_loading:false,
                    pay_type:'',
					do_result_list:[
						{
							id:1,
							name:'通过'
						},
						{
							id:2,
							name:'拒绝'
						}
					],
                    form:{
                        order_number:'',
                        refund_amount:'0',
                        out_refund_no:'',
                        admin_remark:'',
						do_result:1,
						password:'',
                    },
					rules: {
						order_number: {
							required: true,
							message: '请输入订单号',
							trigger: ['change', 'blur']
						},
						refund_amount: {
							required: true,
							message: '请输入退款金额',
							trigger: ['change', 'blur']
						},
						password: {
							required: true,
							message: '请输入员工密码',
							trigger: ['change', 'blur']
						},
					},
                    error:{
                        refund_amount:'',
                        out_refund_no:'',
						password:'',
                    },
                    reset_form: {}
                },
                dlg_preview:{
                    visible: false,
                    img_url: ''
                }
            }
        },
        created() {
            document.title = '售后单列表';
            this.dlg_refund.reset_form = Object.assign({}, this.dlg_refund.form);
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                var status_list = [{id:-1, name: '全部'}];
                this.$client.get('/adminapi/orderrefund/list', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    _this.init_data.pay_type_list = status_list.concat(res.pay_type_name_list);
                    _this.init_data.type_list = status_list.concat(res.type_name_list);
                    _this.init_data.reason_type_list = status_list.concat(res.reason_type_name_list);
                    _this.init_data.status_list = status_list.concat(res.status_name_list);
                    _this.init_data.admin_list = status_list.concat(res.admin_name_list);
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            orderSortChange(column){
                this.table_data.page_info.page = 1;
                if(column.order == "ascending"){
                    if(column.prop == "c_time"){
                        this.form_search.sort_type = 'c_time:asc';
                    }else if(column.prop == "pay_date"){
                        this.form_search.sort_type = 'pay_date:asc';
                    }else if(column.prop == "paid_amount"){
                        this.form_search.sort_type = 'paid_amount:asc';
                    }
                }else if(column.order == "descending") {
                    if(column.prop == "c_time"){
                        this.form_search.sort_type = 'c_time:desc';
                    }else if(column.prop == "pay_date"){
                        this.form_search.sort_type = 'pay_date:desc';
                    }else if(column.prop == "paid_amount"){
                        this.form_search.sort_type = 'paid_amount:desc';
                    }
                }else{
                    return;
                }
                this.getList();
            },
            goToDelivery(order_number,pay_type){
                this.dlg_refund.form.order_number = order_number;
                this.dlg_refund.pay_type = pay_type;
                this.dlg_refund.visible = true;
            },
            submitRefund(){
                var _this = this;
                var params={
                    order_number:this.dlg_refund.form.order_number,
                    refund_amount:this.dlg_refund.form.refund_amount,
                    out_refund_no:this.dlg_refund.form.out_refund_no,
                    admin_remark:this.dlg_refund.form.admin_remark,
					do_result:this.dlg_refund.form.do_result,
					password:this.dlg_refund.form.password,
                };
                _this.dlg_refund.visible = true;
                _this.dlg_refund.btn_loading = true;
                this.$client.post('/adminapi/orderrefund/orderrefund', params, function(res,message){
                    _this.$message(message);
                    _this.dlg_refund.btn_loading = false;
                    _this.dlg_refund.visible = false;
                    _this.getList();
                },function(res){
                    _this.dlg_refund.btn_loading = false;
                });
            },
            closeRefund(){
                for(var key in this.dlg_refund.form){
                    this.dlg_refund.form[key] = this.dlg_refund.reset_form[key];
                }
                this.$nextTick(()=>{
                    this.$refs.formRefund.clearValidate();
            })
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            },
            create_range(newVal){
                //console.log(newVal);
                if(newVal == null){
                    this.form_search.start_create_date = '';
                    this.form_search.end_create_date = '';
                }else{
                    this.form_search.start_create_date = newVal[0];
                    this.form_search.end_create_date = newVal[1];
                }
            },
            complete_range(newVal){
                //console.log(newVal);
                if(newVal == null){
                    this.form_search.start_complete_date = '';
                    this.form_search.end_complete_date = '';
                }else{
                    this.form_search.start_complete_date = newVal[0];
                    this.form_search.end_complete_date = newVal[1];
                }
            }
        }
    }
</script>
<style>

</style>
<style scoped>
    .status-0{
        color: #9a9a9a;
    }
    .status-1{
        color: #F31A5C;
    }
    .status-2{
        color: #F27918;
    }
    .status-3{
        color: #0C67F0;
    }
    .status-9{
        color: #04B365;
    }
    .status-10{
        color: #666;
    }
</style>